import React from 'react'
import { withRouter, Redirect } from 'react-router-dom'
import { connect } from 'react-redux'
import NProgress from 'nprogress'
import { Helmet } from 'react-helmet'
import BRAND from 'brand'
import WhatsAppButton from 'components/cleanui/layout/WhatsAppButton'
import PublicLayout from './Public'
import AuthLayout from './Auth'
import MainLayout from './Main'

const Layouts = {
  public: PublicLayout,
  auth: AuthLayout,
  main: MainLayout,
}

const mapStateToProps = ({ user }) => ({ user })
let previousPath = ''

function BootstrappedLayout({
  Container,
  children,
  isUserAuthorized,
  isUserLoading,
  isAuthLayout,
  currentUrl,
}) {
  // show loader when user in check authorization process, not authorized yet and not on login pages
  if (isUserLoading && !isUserAuthorized && !isAuthLayout) {
    return null
  }
  // redirect to login page if current is not login page and user not authorized,
  // carrying the attempted URL so login can land back on it
  if (!isAuthLayout && !isUserAuthorized) {
    const redirect =
      currentUrl && currentUrl !== '/' ? `?redirect=${encodeURIComponent(currentUrl)}` : ''
    return <Redirect to={`/auth/login${redirect}`} />
  }
  // in other case render previously set layout
  return <Container>{children}</Container>
}

function Layout({ user, children, location: { pathname, search } }) {
  // NProgress & ScrollTop Management
  const currentPath = pathname + search
  if (currentPath !== previousPath) {
    window.scrollTo(0, 0)
    NProgress.start()
  }
  previousPath = currentPath

  // Layout Rendering
  const getLayout = () => {
    if (pathname === '/') {
      return 'public'
    }
    if (/^\/auth(?=\/|$)/i.test(pathname)) {
      return 'auth'
    }
    return 'main'
  }

  const Container = Layouts[getLayout()]
  const isUserAuthorized = user.authorized
  const isUserLoading = user.loading
  const isAuthLayout = getLayout() === 'auth'

  return (
    <>
      <Helmet titleTemplate={BRAND.titleTemplate} title="Portal" />
      <WhatsAppButton />
      {BootstrappedLayout({
        Container,
        children,
        isUserAuthorized,
        isUserLoading,
        isAuthLayout,
        currentUrl: pathname + search,
      })}
    </>
  )
}

export default withRouter(connect(mapStateToProps)(Layout))
